import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user ? user.user.roles[0] : null;
  console.log("🚀 ~ Navdata ~ user:", user?.user?.roles);
  console.log("🚀 ~ role:", role);

  const [isOrganizationSales, setIsOrganizationSales] = useState(false);
  const [isOrganizationSalesMobile, setIsOrganizationSalesMobile] =
    useState(false);

  const [isPrimarySetup, setIsPrimarySetup] = useState(false);
  const [isExpenseSetup, setIsExpenseSetup] = useState(false);
  const [isReports, setIsReports] = useState(false);
  const [isSupplierMenu, setIsSupplierMenu] = useState(false);
  const [iscurrentState, setIscurrentState] = useState(
    role === "BillingUser" ? "organization-sales" : "Dashboard"
  );
  const [isSettings, setIsSettings] = useState(false);

  const updateIconSidebar = (e) => {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      iconItems.forEach((item) => {
        item.classList.remove("active");
        const id = item.getAttribute("subitems");
        if (document.getElementById(id)) {
          document.getElementById(id).classList.remove("show");
        }
      });
    }
  };

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    ...(role === "BillingUser || Waiter"
      ? [
          {
            id: "organization-sales",
            label: "Organization Sales",
            icon: "ri-currency-line",
            link: "/organization-pos",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("organization-sales");
              setIsOrganizationSales(!isOrganizationSales);
              navigate("/organization-pos");
            },
          },

          // {
          //   id: "organization-sales-mobile",
          //   label: "waiter order",
          //   icon: "ri-currency-line",
          //   link: "/organization-pos-mobile",
          //   click: (e) => {
          //     e.preventDefault();
          //     setIscurrentState("organization-sales");
          //     setIsOrganizationSalesMobile(!isOrganizationSalesMobile);
          //     navigate("/organization-pos-mobile");
          //   },
          // },
        ]
      : [
          // {
          //   id: "Dashboard",
          //   label: "Dashboard",
          //   icon: "ri-dashboard-line",
          //   link: "/dashboard",
          //   click: (e) => {
          //     e.preventDefault();
          //     setIscurrentState("Dashboard");
          //     navigate("/dashboard");
          //   },
          // },
          {
            id: "Dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-line",
            link: role === "SuperAdmin" ? "/dashboard" : "/org-dashboard",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("Dashboard");
              const targetPath =
                role === "SuperAdmin" ? "/dashboard" : "/org-dashboard";
              console.log(`Navigating to ${targetPath}`); // Debug
              navigate(targetPath);
            },
          },
          ...(role === "SuperAdmin" || role === "GeneralAdmin"
            ? [
                {
                  id: "primarySetup",
                  label: "Primary Setup",
                  icon: "ri-apps-2-line",
                  link: "/#",
                  click: (e) => {
                    e.preventDefault();
                    setIsPrimarySetup(!isPrimarySetup);
                    setIscurrentState("primarySetup");
                    updateIconSidebar(e);
                  },
                  stateVariables: isPrimarySetup,
                  subItems: [
                    ...(role === "GeneralAdmin"
                      ? [
                          {
                            id: "general_crud",
                            label: "User Management",
                            icon: "ri-group-line",
                            link: "/list-users-general-admin",
                            parentId: "primarySetup",
                            click: (e) => {
                              e.preventDefault();
                              setIscurrentState("general_crud");
                              navigate("/list-users-general-admin");
                            },
                          },
                        ]
                      : []),
                    {
                      id: "table-management",
                      label: "Table Management",
                      icon: "ri-apps-2-line",
                      link: "/table-management",
                      parentId: "primarySetup",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("table-management");
                        navigate("/table-management");
                      },
                    },
                    {
                      id: "menu-category",
                      label: "Menu Category",
                      icon: "ri-apps-2-line",
                      link: "/menu-category",
                      parentId: "primarySetup",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("menu-category");
                        navigate("/menu-category");
                      },
                    },
                    {
                      id: "menu-item",
                      label: "Menu Item",
                      icon: "ri-apps-2-line",
                      link: "/menu-item",
                      parentId: "primarySetup",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("menu-item");
                        navigate("/menu-item");
                      },
                    },
                    {
                      id: "discount",
                      label: "Discount Offers",
                      icon: "ri-currency-line",
                      link: "/discount-offer",
                      parentId: "primarySetup",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("discount");
                        navigate("/discount-offer");
                      },
                    },
                    // {
                    //   id: "expense-heading",
                    //   label: "Expense Heading",
                    //   icon: "ri-apps-2-line",
                    //   link: "/expense-heading",
                    //   parentId: "expenseSetup",
                    //   click: (e) => {
                    //     e.preventDefault();
                    //     setIscurrentState("expense-heading");
                    //     navigate("/expense-heading");
                    //   },
                    // },
                  ],
                },
              ]
            : []),
          ...(role === "SuperAdmin"
            ? [
                {
                  id: "OrganizationManagement",
                  label: "Org Management",
                  icon: "ri-group-line",
                  link: "/organization-management",
                  click: (e) => {
                    e.preventDefault();
                    setIscurrentState("OrganizationManagement");
                    navigate("/organization-management");
                  },
                },
                {
                  id: "theme",
                  label: "Theme",
                  icon: "ri-apps-2-line",
                  link: "/theme",
                  click: (e) => {
                    e.preventDefault();
                    setIscurrentState("theme");
                    navigate("/theme");
                  },
                },
                {
                  id: "currency",
                  label: "Currency",
                  icon: "ri-currency-line",
                  link: "/currency",
                  click: (e) => {
                    e.preventDefault();
                    setIscurrentState("currency");
                    navigate("/currency");
                  },
                },
                {
                  id: "unit",
                  label: "Unit",
                  icon: "ri-currency-line",
                  link: "/unit",
                  click: (e) => {
                    e.preventDefault();
                    setIscurrentState("unit");
                    navigate("/unit");
                  },
                },
                {
                  id: "organization-sitemap",
                  label: "Organization Sitemap",
                  icon: "ri-group-line",
                  link: "/sitemap",
                  click: (e) => {
                    e.preventDefault();
                    setIscurrentState("organization-sitemap");
                    navigate("/sitemap");
                  },
                },
              ]
            : []),
          ...(role !== "SuperAdmin"
            ? [
                {
                  id: "update-profile",
                  label: "Update Profile",
                  icon: "ri-user-line",
                  link: "/update-profile",
                  click: (e) => {
                    e.preventDefault();
                    setIscurrentState("update-profile");
                    navigate("/update-profile");
                  },
                },
              ]
            : []),
          {
            id: "organization-sales",
            label: "Organization Sales",
            icon: "ri-currency-line",
            link: "/organization-pos",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("organization-sales");
              setIsOrganizationSales(!isOrganizationSales);
              navigate("/organization-pos");
            },
          },

          {
            id: "organization-sales-mobile",
            label: "Waiter Order",
            icon: "ri-currency-line",
            link: "/organization-pos-mobile",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("organization-sales");
              setIsOrganizationSalesMobile(!isOrganizationSalesMobile);
              navigate("/organization-pos-mobile");
            },
          },

          {
            id: "organization-order-token",
            label: "Organization Token",
            icon: "ri-currency-line",
            link: "/order-token",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("order-token");
              navigate("/order-token");
            },
          },
          {
            id: "organization-user",
            label: "Customer",
            icon: "ri-user-line",
            link: "/organization-user",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("organization-user");
              navigate("/organization-user");
            },
          },

           ...(role === "SuperAdmin" 
            ? [
                {
            id: "tenant",
            label: "Tenant",
            icon: "ri-apps-2-line",
            link: "/tenant", //baki
            click: (e) => {
              e.preventDefault();
              setIscurrentState("tenant");
              navigate("/tenant"); //baki
            },
          },
              ]
            : []),
          {
            id: "contact-message",
            label: "Contact Messages",
            icon: "ri-apps-2-line",
            link: "/contact-message",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("contact-message");
              navigate("/contact-message");
            },
          },
          {
            id: "order-management",
            label: "Order Management",
            icon: "ri-apps-2-line",
            link: "/order-management",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("order-management");
              navigate("/order-management");
            },
          },
          {
            id: "purchase",
            label: "Purchase",
            icon: "ri-apps-2-line",
            link: "/purchase",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("purchase");
              navigate("/purchase");
            },
          },

          // Supplier dropdown menu
          {
            id: "supplier-menu",
            label: "Supplier",
            icon: "ri-user-2-line",
            link: "/#",
            click: (e) => {
              e.preventDefault();
              setIsSupplierMenu(!isSupplierMenu);
              setIscurrentState("supplier-menu");
              updateIconSidebar(e);
            },
            stateVariables: isSupplierMenu,
            subItems: [
              {
                id: "supplier",
                label: "Supplier",
                icon: "ri-user-2-line",
                link: "/supplier",
                parentId: "supplier-menu",
                click: (e) => {
                  e.preventDefault();
                  setIscurrentState("supplier");
                  navigate("/supplier");
                },
              },
              {
                id: "supplierPaymentLog",
                label: "Supplier Payment Log",
                icon: "ri-money-dollar-circle-line",
                link: "/supplier-payment-log",
                parentId: "supplier-menu",
                click: (e) => {
                  e.preventDefault();
                  setIscurrentState("supplierPaymentLog");
                  navigate("/supplier-payment-log");
                },
              },
            ],
          },
          // {
          //   id: "supplier",
          //   label: "Supplier",
          //   icon: "ri-apps-2-line",
          //   link: "/supplier",
          //   click: (e) => {
          //     e.preventDefault();
          //     setIscurrentState("supplier");
          //     navigate("/supplier");
          //   },
          // },
          // {
          //   id: "supplierPaymentLog",
          //   label: "Supplier Payment Log",
          //   icon: "ri-apps-2-line",
          //   link: "/supplier-payment-log",
          //   click: (e) => {
          //     e.preventDefault();
          //     setIscurrentState("supplierPaymentLog");
          //     navigate("/supplier");
          //   },
          // },
          {
            id: "bank",
            label: "Bank",
            icon: "ri-apps-2-line",
            link: "/bank",
            click: (e) => {
              e.preventDefault();
              setIscurrentState("bank");
              navigate("/bank");
            },
          },
          ...(role === "SuperAdmin" || role === "GeneralAdmin"
            ? [
                {
                  id: "reports",
                  label: "Reports",
                  icon: "ri-apps-2-line",
                  link: "/#",
                  click: (e) => {
                    e.preventDefault();
                    setIsReports(!isReports);
                    setIscurrentState("reports");
                    updateIconSidebar(e);
                  },
                  stateVariables: isReports,
                  subItems: [
                    {
                      id: "sales-summary",
                      label: "Stock Summary",
                      icon: "ri-apps-2-line",
                      link: "/stock-summary",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("stock-summary");
                        navigate("/stock-summary");
                      },
                    },
                    {
                      id: "sales",
                      label: "Sales",
                      icon: "ri-apps-2-line",
                      link: "/sales-report",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("sales");
                        navigate("/sales-report");
                      },
                    },
                    {
                      id: "supplierPurchased",
                      label: "Supplier Performance",
                      icon: "ri-apps-2-line",
                      link: "/supplier-purchased-report",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("supplierPurchased");
                        navigate("/supplier-purchased-report");
                      },
                    },
                    {
                      id: "supplierPurchasedItems",
                      label: "ItemWise Report",
                      icon: "ri-apps-2-line",
                      link: "/supplier-purchased-items",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("supplierPurchasedItems");
                        navigate("/supplier-purchased-items");
                      },
                    },
                    {
                      id: "bankStatement",
                      label: "Bank Statement",
                      icon: "ri-apps-2-line",
                      link: "/bank-statement",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("bankStatement");
                        navigate("/bank-statement");
                      },
                    },
                    {
                      id: "counterCashTransaction",
                      label: "Counter Cash Transaction",
                      icon: "ri-apps-2-line",
                      link: "/counter-cash-transaction",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("counterCashTransaction");
                        navigate("/counter-cash-transaction");
                      },
                    },

                    {
                      id: "creditList",
                      label: "Credit List",
                      icon: "ri-apps-2-line",
                      link: "/credit-list",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("creditList");
                        navigate("/credit-list");
                      },
                    },
                    {
                      id: "daybook",
                      label: "Daybook",
                      icon: "ri-apps-2-line",
                      link: "/daybook",
                      parentId: "reports",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("daybook");
                        navigate("/daybook");
                      },
                    },
                  ],
                },
              ]
            : []),

          ...(role === "SuperAdmin" || role === "GeneralAdmin"
            ? [
                {
                  id: "expenseSetup",
                  label: "Expenses",
                  icon: "ri-apps-2-line",
                  link: "/#",
                  click: (e) => {
                    e.preventDefault();
                    setIsExpenseSetup(!isExpenseSetup);
                    setIscurrentState("expenseSetup");
                    updateIconSidebar(e);
                  },
                  stateVariables: isExpenseSetup,
                  subItems: [
                    {
                      id: "category",
                      label: "Expense Category",
                      icon: "ri-apps-2-line",
                      link: "/expense-category",
                      parentId: "expenseSetup",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("category");
                        navigate("/expense-category");
                      },
                    },
                    {
                      id: "expense-heading",
                      label: "Expense Heading",
                      icon: "ri-apps-2-line",
                      link: "/expense-heading",
                      parentId: "expenseSetup",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("expense-heading");
                        navigate("/expense-heading");
                      },
                    },
                    {
                      id: "expense-detail",
                      label: "Expense Detail",
                      icon: "ri-apps-2-line",
                      link: "/expense-detail",
                      parentId: "expenseSetup",
                      click: (e) => {
                        e.preventDefault();
                        setIscurrentState("expense-detail");
                        navigate("/expense-detail");
                      },
                    },
                  ],
                },
              ]
            : []),
          ...(role === "SuperAdmin"
            ? [
                {
                  id: "Settings",
                  label: "Settings",
                  icon: "ri-settings-5-line",
                  link: "/view-profile",
                  parentId: "settings",
                  click: (e) => {
                    e.preventDefault();
                    setIsSettings(!isSettings);
                    setIscurrentState("Settings");
                    updateIconSidebar(e);
                    navigate("/view-profile");
                  },
                  stateVariables: isSettings,
                  subItems: [
                    {
                      id: "general-settings",
                      label: "General Settings",
                      link: "/settings/general-settings",
                      parentId: "settings",
                    },
                  ],
                },
              ]
            : []),
        ]),
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
